// src/components/TabTwoColumnLayout.js
import React, { useEffect } from "react";
import "./TabTwoColumnLayout.css"; // minimal CSS (use rem units)

import { useLocation } from "react-router-dom";
import { logVisit } from "../utils/wkCommon";

export default function TabTwoColumnLayout({
  leftControls,   // JSX node: controls area (search, filters)
  leftList,       // JSX node: list (rows, clickable)
  rightForm,      // JSX node: detail/form for selected item
  leftWidth = "60%", // percentage or css value
}) {

  const location = useLocation();

  useEffect(() => {
    logVisit({
      path: location.pathname,
      query: location.search,
    });
  }, [location.pathname]);
  
  
  return (
    <div className="twocol-layout" style={{ fontSize: "1rem" }}>
      <div className="twocol-left" style={{ flexBasis: leftWidth }}>
        <div className="twocol-left-controls">{leftControls}</div>
        <div className="twocol-left-list">{leftList}</div>
      </div>

      <div className="twocol-right">
        <div className="twocol-right-inner">{rightForm}</div>
      </div>
    </div>
  );
}
